
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amanaki-thao-dien/stories",
      function () {
        return require("private-next-pages/amanaki-thao-dien/stories/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amanaki-thao-dien/stories"])
      });
    }
  